import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
export default function uploadDocumentReducer(state = [], action) {
	const initialState = {
		uploadedData: {},
		userTypeData: [],
		uploadedImages: {},
		deletedData: {},
		uploadedSpecialistData: {},
		specialistDocument: [],
		specialistDocumentData: {},
		docTypes: []

	};
	switch (action.type) {
		case types.UPLOAD_APPOINTMENT_DOCUMENT:
			return objectAssign({}, state, {
				uploadedData: action.uploadedData
			});
		case types.GET_DOCUMENT_TYPE:
			return objectAssign({}, state, {
				userTypeData: action.userTypeData
			});
		case types.GET_APPOINTMENT_DOCUMENT:
			return objectAssign({}, state, {
				uploadedImages: action.uploadedImages
			});
		case types.DELETE_DOCUMENT:
			return objectAssign({}, state, {
				deletedData: action.deletedData
			});
		case types.UPLOAD_SPECIALIST_DOCUMENT:
			return objectAssign({}, state, {
				uploadedSpecialistData: action.uploadedSpecialistData
			});
		case types.GET_SPECIALIST_DOCUMENT:
			return objectAssign({}, state, {
				specialistDocument: action.specialistDocument
			});
		case types.GET_SPECIALIST_DOCUMENT_BY_ID:
			return objectAssign({}, state, {
				specialistDocumentData: action.specialistDocumentData
			});
			case types.GET_ALL_DOCUMENT_TYPES:
			return objectAssign({}, state, {
				docTypes: action.docTypes,
				doclength: action.doclength
			});
			case types.GET_SPECIALIST_DOCUMENT_AND_STATUS:
				return objectAssign({},state,{
					docAndStatus: action.docAndStatus
				})
		default:
			return state;
	}
}